<template>
  <modal :state="state" :index="index" @toggle-modal="cancel" class="md fds">

    <div slot="body">
      <h3 class="modal-title">Configure Process</h3>
      <p class="modal-subheading mb-3 pb-1">Map data to Variables</p>
      <div class="container mb-0">
        <row>
          <label class="label-lg text-color-secondary">Map Request</label>
        </row>
      </div>
      <div class="container mb-4">
        <template v-for="variable in variableOptionsFor">
            <row component-row class="align-left mb-3">
              <column size="50%-40">
                <a-select :id="variable.id"
                          :options="objectModelOptions"
                          v-model="mappedVariableFor(variable).source_id"
                ></a-select>
              </column>

              <column size="75" class="d-flex justify-content-center">
                <div class="toggle-arrow checked disabled">
                  <input type="checkbox" disabled="disabled" value="Push">
                </div>
              </column>

              <column size="50%-35">
                <div>
                  <h4 class="p" :class="isRequired(variable)"><strong>{{variable.name}} <required-indicator v-if="variable.is_input_required" /></strong></h4>
                </div>
              </column>
            </row>
        </template>
      </div>
      <div class="row pt-2 modal-btn-group">
        <div class="col">
          <div class="cta d-flex justify-content-end">
            <button @click="cancel" class="btn block red outline">Cancel</button>
          </div>
        </div>
        <div class="col">
          <div class="cta d-flex justify-content-start">
            <button @click="save" class="btn block green">Save</button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
import Vue from "vue";
import ModalComponentMixin from "~/mixins/modalComponentMixin";
import {Hash} from "~/interfaces/hashInterfaces";
import ObjectModel from "~/models/objectModel";
import {ModelType} from "~/enums/modelType";
import ObjectModelTrigger from "~/models/objectModelTriggers/objectModelTrigger";
import ProcessFlowSubmissionMappedVariable from "~/models/processFlows/processFlowSubmissionMappedVariable";
import ObjectModelAction from "~/models/objectModelActions/objectModelAction";

export default Vue.extend({
  mixins: [
    ModalComponentMixin,
  ],
  props: {
    processFlow: {
      type: Object as () => Hash, // object will look like a process flow, but is not a process flow,
      required: true,
    },
    parentModel: {
      type: Object as () => ObjectModelTrigger | ObjectModelAction,
      required: true
    },
    objectModel: {
      type: Object as () => ObjectModel,
      required: true
    },
  },
  data: function() {
    return {
      variableMaps: []
    }
  },
  beforeMount() {
    // create a copy of variable maps that can be saved at once later
    this.variableMaps = ProcessFlowSubmissionMappedVariable.cloneMappedVariables(this.variableOptionsFor, this.parentModel);
  },
  methods: {
    cancel(event) {
      this.emitHideModal(event);
    },
    isRequired(variable) {
      return {"required": variable.is_input_required}
    },
    mappedVariableFor(variable) {
      return this.variableMaps.find(v => v.process_flow_variable_id === variable.id);
    },
    save(): void {
      ProcessFlowSubmissionMappedVariable.setMappedVariables(this.variableMaps, this.parentModel);
      this.emitHideModal();
    },
  },
  computed: {
    inputVariables(){
      return this.processFlow.variables.filter(v => v.is_input)
    },
    variableOptionsFor() {
      if (!this.objectModel) return [];

      return this.inputVariables.filter(v => {
        // TODO: Alex: ProcessFlow: Make this nicer
        return v.variable_type === ModelType.ObjectModel && v.reference_path?.nodes?.[0]?.reference_id === this.objectModel.id;
      });
    },
    isBulkAction() {
      return this.parentModel instanceof ObjectModelAction && (this.parentModel as ObjectModelAction).allows_bulk;
    },
    isCollection() {
      return this.isBulkAction && (this.parentModel as ObjectModelAction).treat_as_bulk;
    },
    objectModelOptions() {
      if (!this.isBulkAction) {
        return [{label: this.objectModel.title, value: this.objectModel.id}]
      } else if (this.isCollection) {
        return [{label: `${this.objectModel.title} collection`, value: this.objectModel.id}]
      } else {
        return [
          {label: this.objectModel.title, value: this.objectModel.id},
          {label: `${this.objectModel.title} collection`, value: this.objectModel.id + "_collection"}
        ]
      }
    }
  },
});
</script>